import React from 'react';

const PendingStatus: React.FC = () => {
  return (
    <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
      <div className="flex items-center">
        <svg
          className="animate-spin h-5 w-5 text-yellow-500 mr-3"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
        <div>
          <h4 className="text-yellow-800 font-medium flex items-center">
            <span className="mr-2">🔍</span>
            Đang crawl ảnh...
          </h4>
          <p className="text-yellow-700 text-sm mt-1">
            Hệ thống đang thu thập ảnh từ Facebook. Quá trình này có thể mất vài
            phút.
          </p>
        </div>
      </div>

      {/* Progress indicator */}
      <div className="mt-4">
        <div className="flex items-center text-xs text-yellow-600">
          <div className="flex-1 bg-yellow-200 rounded-full h-2 mr-3">
            <div
              className="bg-yellow-500 h-2 rounded-full animate-pulse"
              style={{ width: '40%' }}
            ></div>
          </div>
          <span>Đang xử lý...</span>
        </div>
      </div>
    </div>
  );
};

export default PendingStatus;
